import React from 'react'
import { Box } from '@mui/material'
import { motion } from 'framer-motion'
import { styled } from '@mui/material/styles'
import { formlessColors } from '@zuto/theme/src/mui/Colors'
import type { InterstitialStage } from '../../../../../types/ui'

const MotionBox = motion.create(Box)

const ProgressDot = styled(MotionBox)(() => ({
  height: '6px',
  borderRadius: '999px'
}))

type ProgressDotsProps = {
  stage: InterstitialStage
}

const ProgressDots: React.FC<ProgressDotsProps> = ({ stage }) => {
  const stageIndex = stage === 'intro' ? 0 : stage === 'transition' ? 1 : 2
  const activeColor = formlessColors.progressActive
  const inactiveColor = formlessColors.progressInactive

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: '8px',
        marginBottom: 12
      }}
    >
      {[0, 1, 2].map((i) => {
        const isCompletedOrCurrent = i <= stageIndex
        const isCurrent = i === stageIndex

        return (
          <ProgressDot
            key={i}
            initial={{ width: 24 }}
            animate={{
              width: isCurrent ? 40 : 24,
              backgroundColor: isCompletedOrCurrent
                ? activeColor
                : inactiveColor
            }}
            transition={{ duration: 0.3 }}
          />
        )
      })}
    </Box>
  )
}

export default ProgressDots
